module.exports = __webpack_public_path__ + "static/media/Shox 03 BG.3ab5d41d.png";